<template>
    <div
        v-click-outside="closeList"
        :class="['token-list', {'token-list--min-width': minWidth}]"
    >
        <div
            id="token-list"
            :class="['token-list__item', 'token-list__item--active', tokenListItemClasses]"
            @click="toggleList"
        >
            <partner-logo-tile
                id="token-list-selected-item"
                :item="activeItem"
                is-small
                :is-logo-hidden="!minWidth"
            />
            <i
                v-if="hasMultipleItems"
                class="icon-chevron"
            />
        </div>

        <div
            v-if="hasMultipleItems"
            id="token-list-dropdown"
            :class="['token-list__full-list', {'token-list__full-list--show': isShown}]"
        >
            <div class="token-list__scroll">
                <div
                    v-for="(token, index) in tokensListFiltered"
                    :key="index"
                    class="token-list__item"
                    @click="selectToken(token)"
                >
                    <partner-logo-tile
                        :id="`token-list-dropdown-item-${index}`"
                        is-small
                        :item="token"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Components
import partnerLogoTile from '@webapp/components/partner-logo/partner-logo-tile.vue';

export default {
    name: 'token-list',
    components: {
        partnerLogoTile,
    },
    props: {
        activeItem: {
            type: Object,
            default: () => ({}),
        },
        tokensList: {
            type: Array,
            default: () => ([]),
        },
        minWidth: {
            type: Boolean,
            default: false,
        },
        hasShadow: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isShown: false,
        };
    },
    computed: {
        tokensListFiltered() {
            return this.tokensList.filter((token) => {
                if (token.shortName === 'CHZ') {
                    token.partnerLogo = require('../../assets/chz-logo-round.webp');
                }

                if (token.name !== this.activeItem.name) {
                    return token;
                }

                return false;
            });
        },

        // If the tokens list doesn't contain more than 1 item, dropdown can be hidden along with the chevron
        hasMultipleItems() {
            return this.tokensListFiltered.length > 0;
        },

        tokenListItemClasses() {
            return {
                'token-list__item--shown': this.isShown,
                'token-list__item--shadow': this.hasShadow,
                'token-list__item--single': !this.hasMultipleItems,
            };
        },
    },
    methods: {
        closeList() {
            this.isShown = false;
        },

        toggleList() {
            this.isShown = !this.isShown;
        },

        selectToken(token) {
            this.$emit('selectToken', token);
            this.closeList();
        },
    },
};
</script>

<style lang="scss" scoped>
.token-list {
    color: $cyprus-color;
    position: relative;

    &--min-width {
        .token-list {
            &__item {
                min-width: 28rem;
                padding: 1.6rem 3.2rem 1.8rem;

                @include max-width(sm) {
                    width: 27rem;
                }
            }

            &__active {
                padding: 0;
            }
        }
    }

    &__full-list {
        display: none;
        position: absolute;
        z-index: 1001;
        max-width: 34.4rem;
        border-radius: 0 0 1.8rem 1.84rem;
        background: $white-color;
        box-shadow: 0 2.2rem 2.6rem 0 rgba($black-color, 0.2);

        &--show {
            display: block;
        }
    }

    &__scroll {
        max-height: 28rem;
        overflow-y: auto;
        overflow-x: hidden;

        @include min-width(lg) {
            max-height: 42rem;
        }
    }

    &__item {
        display: flex;
        padding: 1.6rem 3.2rem 1.8rem;
        align-items: center;
        border-bottom: 0.1rem solid $gainsboro-color;

        @include max-width(sm) {
            min-width: initial;
            overflow: hidden;
            box-sizing: border-box;
        }

        &--active {
            border-bottom: none;
            padding: 0;
            font-size: 3.6rem;
            justify-content: space-between;
        }

        &--shown {
            &.token-list {
                &__item--shadow {
                    box-shadow: 0 2.2rem 2.6rem 0 rgba($black-color, 0.2);
                    border-bottom: 0.1rem solid $gainsboro-color;
                }
            }

            i {
                transform: none;
            }
        }

        &:last-child {
            border: none;
        }

        &:hover:not(&--single) {
            cursor: pointer;
            background: linear-gradient(180deg, rgba($blue-lagoon-color, 0.05) 0%, rgba($cyprus-color, 0.05) 100%);
        }

        img {
            width: 5.5rem;
            height: 5.5rem;
        }

        i {
            margin-left: 1rem;
            font-size: 1rem;
            position: relative;
            top: 0.7rem;
            transform: rotate(180deg);

            @include min-width(lg) {
                font-size: 1.2rem;
                margin-left: 1rem;
            }
        }
    }
}
</style>